/**
 * 消息/聊天列表相关API接口
 */
import { mateHttp } from '~/utils/mate/mateRequest'
import type { ApiResponse } from '~/utils/mate/mateRequest'

// Mate背景信息参数
export interface MateBackgroundDetail {
    background: string
    video: boolean
}

// Mate形象图片信息参数
export interface MateFigureDetail {
    figure: string
    video: boolean
}

// Mate聊天消息
export interface LastMessage {
    by_user: boolean // 是：用户说的话，否：AI回复的话
    create_time: number // 消息时间戳
    is_emoji: boolean // 是否表情图片
    message_scene: string // 聊天场景：和mate聊天、roleplay聊天
    message_time_format: string // 消息时间
    msg: string // 消息内容
    msg_id: number // 消息ID
    msg_type: string // 消息类型
}

// Mate标签
export interface MateLabel {
    id: number
    name: string
    color?: string
}

// Mate信息（年龄、身高等）
export interface MateInformation {
    key: string
    value: string
}

// 消息列表项
export interface MessageItem {
    avatar: string // mate头像地址
    background: string // 聊天场景背景
    background_detail: MateBackgroundDetail // 聊天场景背景详情
    conversation_id: number // 会话 ID
    figure_details: MateFigureDetail[] // Mate形象详细数据(包含是否视频)
    figure_images: string[] // 形象图片
    figure_type: string // 形象类型2d/3d
    last_message: LastMessage // 最后一条消息
    match_mate_id: number // 匹配的mate ID
    mate_category: string // mate分类
    mate_category_color: string // mate分类颜色
    mate_category_text: string // mate分类文案
    mate_id: number // mate ID
    name: string // mate名称

    // 以下字段用于角色详情展示（可能在某些接口中返回）
    psy_gender?: number // 性别：1=男，0=女，-1=未知
    labels?: MateLabel[] // 角色标签
    introduce?: string // 角色介绍
    informations?: MateInformation[] // 角色信息（年龄、身高等）
    birthday?: string // 生日，格式：YYYYMMDD（如：19900101）
    selected?: boolean // 是否选中
}

// 消息列表响应
export interface MessageListResponse {
    can_create_more_mate: boolean // 是否可以创建更多mate
    h5_display_config?: string // H5页面展示配置
    h5_recommend_info?: string // H5推荐信息
    has_next: boolean // 是否有下一页
    max_mate_num: number // 最大mate数量
    messages?: MessageItem[] // 消息列表（可能为空）
    offset?: string // 偏移量（可能为空）
}

/**
 * 获取消息列表
 * @param offset 偏移量（时间戳，用于分页）
 * @returns Promise<ApiResponse<MessageListResponse> | null>
 */
export const getMessageList = async (
    offset?: string
): Promise<ApiResponse<MessageListResponse> | null> => {
    try {
        const params: { offset?: string } = {}

        // 如果有offset参数，则添加
        if (offset) {
            params.offset = offset
        }

        // 调用 mateHttp.get
        const response = await mateHttp.get<MessageListResponse>(
            '/api/v1/h5/roles/auth/tab/messages',
            params
        )

        return response
    } catch (err) {
        console.error('获取消息列表异常:', err)
        return null
    }
}
